export default __webpack_public_path__ + "static/media/Sage's Helm of the Soaring Heart.4ac89ec0.jpg";